module.exports = "<div class=\"container container-fluid\">\n  <a data-toggle=\"tooltip\"\n     title=\"{{participant.affiliation}}\"\n  > {{participant.firstName}} {{participant.lastName}}\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/home/plenary-speakers/speaker/speaker.component.html
// module id = ../../../../../src/app/home/plenary-speakers/speaker/speaker.component.html
// module chunks = main